import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface CloseButtonProps {
  onClick?: () => void;
}

export function CloseButton(props: CloseButtonProps) {
  const { onClick } = props;
  return (
    <IconButton
      color="primary"
      aria-label="Menü schließen"
      data-testid="burgermenu_close_button"
      onClick={onClick}
      sx={{
        p: '0.4rem',
        m: 0,
        '&.MuiButton-root': {
          backgroundColor: 'transparent',
        },
      }}
    >
      <CloseIcon />
    </IconButton>
  );
}
